import React from 'react';

import s from './style.module.css';

type Props = {
  onClick: () => void;
  disabled?: boolean;
  children: React.ReactNode;
};

/**
 * The "Change Email / Change Phone Number" action of a locked identifier
 * field, sitting opposite its label — the b2b auth card pattern. The parent
 * wraps the field in a `position: relative` container.
 */
const ChangeButton: React.VFC<Props> = ({ onClick, disabled, children }) => (
  <button className={s.changeButton} onClick={onClick} disabled={disabled} type="button">
    {children}
  </button>
);

export { ChangeButton };
